import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import Layout from "../../containers/Layout/Layout";
import {
  loadCompanyAction,
  saveCompanyAction,
  getCompany,
  isSaving
} from "../../../state/trial";
import Loader from "../../atomic/Loader/Loader";
import InputText from "../../atomic/InputText/InputText";
import CheckboxGroup from "react-checkbox-group";
import Information from "../../atomic/Information/Information";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../atomic/Button/Button";
import Panel from "../../atomic/Panel/Panel";
import { withTheme } from "styled-components";

const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const BookingsPage = withTheme(({ theme }) => {
  const company = useSelector(getCompany);
  const dispatch = useDispatch();
  const saving = useSelector(isSaving);
  const [bookType, setBookType] = useState("email");
  const [text, setText] = useState("");
  const [useTryit, setUseTryit] = useState(true);
  const [notifEmail, setNotifEmail] = useState("");
  useEffect(() => {
    if (!company) {
      dispatch(loadCompanyAction());
    }
  }, []);
  useEffect(() => {
    if (company) {
      setBookType(company.bookType || "email");
      setUseTryit(company.useTryit || true);
      setNotifEmail(company.notifEmail || "");
      setText(
        company.bookType === "email"
          ? company.bookEmail || ""
          : company.bookWebsite || ""
      );
    }
  }, [company]);
  if (!company) {
    return (
      <Layout>
        <Loader />
      </Layout>
    );
  }

  const makeCompany = () => {
    const c = { ...company, bookType, useTryit, notifEmail };
    if (bookType === "email") {
      c.bookEmail = text;
    } else {
      c.bookWebsite = text;
    }
    return c;
  };

  return (
    <Layout>
      <h1>Booking details</h1>
      <Panel>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "0px 0px 10px 0px"
          }}
        >
          <input
            style={{ marginRight: "10px" }}
            type="radio"
            value="email"
            checked={bookType === "email"}
            onChange={e => {
              if (e.target.checked) {
                setBookType("email");
              }
            }}
          />
          Book by email
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "0px 0px 10px 0px"
          }}
        >
          <input
            style={{ marginRight: "10px" }}
            type="radio"
            value="website"
            checked={bookType === "website"}
            onChange={e => {
              if (e.target.checked) {
                setBookType("website");
              }
            }}
          />
          Redirect to your website to make a booking
        </div>
        <div>
          <label>
            {bookType === "email" ? "Email for bookings" : "Booking URL"}
          </label>
          <InputText
            value={text}
            onChange={e => setText(e.target.value)}
          ></InputText>
        </div>
        <CheckboxGroup
          name="usetryitout"
          value={useTryit ? ["usetryitout"] : []}
          onChange={v => setUseTryit(v.length > 0)}
        >
          {Checkbox => (
            <>
              <label>
                <Checkbox value="usetryitout" /> Use our booking system for
                lessons with schedule
              </label>
            </>
          )}
        </CheckboxGroup>
        {useTryit && (
          <Information message="When users book the lessons on our website, you get notified by email." />
        )}
        {useTryit && (
          <>
            <label>Notification email</label>
            <InputText
              value={notifEmail}
              onChange={e => setNotifEmail(e.target.value)}
            />
          </>
        )}
        <Buttons>
          {!saving && (
            <Button
              inverted
              onClick={() => dispatch(saveCompanyAction(makeCompany()))}
            >
              Save
            </Button>
          )}
          {saving && (
            <Button inverted>
              <FontAwesomeIcon
                icon={["fas", "spinner"]}
                size="1x"
                color={theme.color5}
                spin
              />
            </Button>
          )}
        </Buttons>
      </Panel>
    </Layout>
  );
});

export default BookingsPage;
